import { render, staticRenderFns } from "./activity-type-widget.vue?vue&type=template&id=1d959c7a&"
import script from "./activity-type-widget.vue?vue&type=script&lang=js&"
export * from "./activity-type-widget.vue?vue&type=script&lang=js&"
import style0 from "./activity-type-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports